import { Box, Container } from '@mui/material';
import YardMap from '../../components/Yard/YardMap';

export default function YardManagementPage() {
    return (
        <Container maxWidth={false} >
            <Box>
                <YardMap />
            </Box>
        </Container>
    );
}